<template>
  <div
    class="container menu-icon-upload"
    :class="mode"
  >
    <el-upload
      v-if="file.path === ''"
      :action="uploadSrc"
      name="img"
      class="micon-upload"
      :show-file-list="false"
      :data="uploadData"
      :on-success="uploadSuccess"
      :on-error="uploadFail"
      :before-upload="beforeUpload"
    >
      <div class="icon"></div>
    </el-upload>
    <template v-else>
      <div class="loader-wrapper">
        <image-loader :src="file.path"></image-loader>
      </div>
      <div class="operator-wrapper">
        <div class="buttons">
          <!-- v-show="" -->
          <!-- <i
            class="btn delete"
            :class="{ disabled: menuLevel === 1 }"
            @click="removeImage"
          ></i> -->
          <el-upload
            :action="uploadSrc"
            class="micon-upload-replace"
            name="img"
            :data="uploadData"
            :on-success="uploadSuccess"
            :on-error="uploadFail"
            :before-upload="beforeUpload"
          >
            <i class="btn h-icon-update"></i>
          </el-upload>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import configuration from 'api/config'
import { LoadingMixin } from 'utils/mixin'
import ImageLoader from 'components/image-loader/image-loader'
import API from 'api/api'
export default {
  name: 'view-icon-upload',
  model: {
    prop: 'file',
    event: 'change'
  },
  props: {
    type: String,
    file: {
      type: Object,
      default () {
        return {
          fileId: -1,
          path: '',
          width: '',
          height: ''
        }
      }
    },
    mode: {
      type: String,
      default: 'normal'
    },
    menuLevel: {
      type: Number,
      default: 2
    }
  },
  computed: {
    uploadSrc () {
      return `${configuration.baseUrl}${configuration.uploadSrc}`
    },
    uploadData () {
      return {
        usageScenario: this.type
      }
    },
    showStyle () {
      let _res = {
        'background-image': `url(${this.file.path})`
      }
      let _width = this.file.width ? parseInt(this.file.width) : 0
      if (_width > 0 && _width < 15) {
        _res['background-repeat'] = 'repeat-x'
      }
      return _res
    }
  },
  data () {
    return {
      loadingInstance: null
    }
  },
  methods: {
    beforeUpload (file) {
      if (!/.(ico|ICO)$/.test(file.name)) {
        this.$message.error(this.$t('common.ico_type_error'))
        return false
      }
      this.loadingInstance = this._getLoading()
      API.common.keepAlive()
      return true
    },
    uploadSuccess (response, file) {
      this.loadingInstance && this.loadingInstance.close()
      if (response.code === '0') {
        this.$message.success(this.$t('common.upload_success'))
        this.$emit('change', {
          fileId: response.data.fileId,
          path: response.data.path,
          width: response.data.width,
          height: response.data.height
        })
        this.$emit('icon-change')
      } else {
        this.$message.error(response.msg)
      }
    },
    uploadFail () {
      this.loadingInstance.close()
      this.$message.error(this.$t('common.upload_error'))
    },
    removeImage () {
      if (this.menuLevel !== 1) {
        this.$emit('change', {
          fileId: -1,
          path: '',
          width: 0,
          height: 0
        })
        this.$emit('icon-change')
      }
    }
  },
  mixins: [LoadingMixin],
  components: {
    ImageLoader
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.menu-icon-upload.container {
  position: relative;
  border-radius: 2px;
  overflow: hidden;
  .operator-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: none;
    .buttons {
      height: 24px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      .btn {
        width: 24px;
        height: 24px;
        font-size: 24px;
        color: #fff;
        display: inline-block;
        vertical-align: top;
        cursor: pointer;
      }
      .micon-upload-replace {
        width: 24px;
        .el-upload-list {
          display: none;
        }
      }
      .disabled {
        cursor: not-allowed;
      }
    }
  }
  &.normal {
    width: 64px;
    height: 64px;
    .micon-upload {
      width: 100%;
      height: 100%;
      .icon {
        width: 64px;
        height: 64px;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .loader-wrapper {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      border: 1px solid rgba(0, 0, 0, 0.08);
    }
    .operator-wrapper {
      box-sizing: border-box;
      padding: 20px 5px;
    }
  }
  &.small {
    width: 68px;
    height: 32px;
    box-sizing: border-box;
    padding: 4px 0;
    .micon-upload {
      width: 24px;
      height: 24px;
      position: relative;
      .icon {
        width: 24px;
        height: 24px;
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .loader-wrapper {
      width: 24px;
      height: 24px;
    }
  }
  &:hover {
    .operator-wrapper {
      background: rgba(0, 0, 0, 0.7);
      display: block;
    }
  }
}
</style>
